import { WomensHealthHero } from '@/components/womens-health/WomensHealthHero'
import { WomensHealthConditions } from '@/components/womens-health/WomensHealthConditions'
import { WomensHealthApproach } from '@/components/womens-health/WomensHealthApproach'
import { WomensHealthTestimonial } from '@/components/womens-health/WomensHealthTestimonial'

export const WomensHealthPage = () => (
  <>
    <WomensHealthHero />
    <WomensHealthConditions />
    <WomensHealthApproach />
    <WomensHealthTestimonial />
  </>
)
